module.exports = __webpack_public_path__ + "images/icons/psp/climate-controlled/10x30.svg";